// src/utils/latestReadWins.js
//
// Overlapping reads of one record: every read is numbered when it starts, and each record remembers the number of the
// read that last landed. A read that finishes after a later-started read of the same record has already landed is
// dropped, so an older snapshot never replaces a newer one. customerWorkflowsStore uses it: the calendar starts
// overlapping reads of one workflow (its first load, the refresh of a customer whose date changed, a lead arriving;
// bug oqWjAMbYK8Q6n4CjA3Tu).

export function latestReadWins() {
  let started = 0
  const landed = new Map()
  return {
    /** Number a read as it starts. */
    start: () => ++started,
    /** Whether the read numbered `sequence` may write `key` (and record that it did). */
    lands(key, sequence) {
      if ((landed.get(key) || 0) > sequence) return false
      landed.set(key, sequence)
      return true
    },
    clear: () => landed.clear(),
  }
}
